import { Injectable } from '@angular/core';
import { Observable, Subject, Subscription } from 'rxjs';
import { ApiService } from '.';
import { ReferenceParams, Res } from '../models';

@Injectable({
  providedIn: 'root'
})
export class ApiSettingsService {

  settings: any;
  settingSubject = new Subject<any>();

  constructor(
    private api: ApiService
  ) { }


  /**
   * 
   * @returns Observable<any>
   */
  listenerSettings(): Observable<any> {

    return this.settingSubject.asObservable();
  }

  /**
   * 
   */
  getSettings(): void {

    let s: Subscription = this.api.post('references/default_settings', null, 'private').subscribe(response => {
      console.log('[RESPONSE] GET SETTINGS: ', response);

      if (response != null) {

        this.settings = response.result;
        this.settingSubject.next(response.result);
      }

      s.unsubscribe();
    },
      error => {
        s.unsubscribe();
      });
  }

  /**
   * 
   */
  getSettingValues(id: string, type: string = null) {

    if (this.settings) {

      let res = this.settings.find(val => val.id == id);

      switch (type) {

        case 'array':

          return res ? JSON.parse(res.value) : [];

        default:

          return res ? res.value : null;
      }

    }
  }

}

